import Box from './src/box.vue';
import { SFCWithInstall, withInstall } from '@touchvue/utils';

export const ToBox: SFCWithInstall<typeof Box> = withInstall(Box);

export { Box };
export * from './src/box';
export * from './src/instance';
